import type React from "react";
import type {ReactNode} from "react";
import type {DashboardItem} from "./services/dashboardsApi";
import {DashboardCard} from "./DashboardCard";
import {DashboardsEmptyState} from "./DashboardsEmptyState";

type Props = {
    id: string;
    title: string;
    subtitle: string;
    dashboards: DashboardItem[];
    /** Shown in place of the grid when the section has no dashboards. */
    emptyText: string;
    emptyAction?: ReactNode;
    onOpen: (d: DashboardItem) => void;
    /** Rename / Delete appear on the cards only when given (Yours). */
    onRename?: (d: DashboardItem) => void;
    onDelete?: (d: DashboardItem) => void;
};

/** One gallery section (Built-in or Yours): heading, then a card grid or an inline empty state. */
export const GallerySection: React.FC<Props> = ({
                                                    id,
                                                    title,
                                                    subtitle,
                                                    dashboards,
                                                    emptyText,
                                                    emptyAction,
                                                    onOpen,
                                                    onRename,
                                                    onDelete,
                                                }) => (
    <section className="dsh-sec" aria-labelledby={id}>
        <div className="dsh-sec-h">
            <h2 id={id} className="dsh-t-section-title">{title}</h2>
            <p className="dsh-t-subtitle">{subtitle}</p>
        </div>
        {dashboards.length ? (
            <div className="dsh-ggrid">
                {dashboards.map(d => (
                    <DashboardCard key={d.id} dashboard={d} onOpen={onOpen} onRename={onRename} onDelete={onDelete}/>
                ))}
            </div>
        ) : (
            <DashboardsEmptyState variant="inline" body={emptyText} action={emptyAction}/>
        )}
    </section>
);
